import axios from "./axios-auth";

const getGeneralLookupUsers = (payload) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/dv-adm/getgenerallookupusers",
      method: "POST",
      data: payload,
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        console.log("getGeneralLookupUsers api", err);
      });
  });

export { getGeneralLookupUsers };
